import React from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import ValueDimensionsCard from './ValueDimensionsCard';
import ChallengeFactorsCard from './ChallengeFactorsCard';

const WeightSelection = () => {
  const { weights, setWeights } = useAssessment();

  const handleWeightChange = (key: keyof typeof weights, value: number[]) => {
    setWeights({ ...weights, [key]: value[0] });
  };

  return (
    <div className="container mx-auto py-8 px-4 w-full max-w-[1600px]">
      <div className="text-center space-y-6">
        <h1 className="text-4xl md:text-5xl font-bold text-primary">AI Opportunity Assessment</h1>
        <p className="text-xl md:text-2xl text-gray-600">
          Evaluate which AI initiatives best serve your jurisdiction's goals
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mt-12">
        <ValueDimensionsCard weights={weights} onWeightChange={handleWeightChange} />
        <ChallengeFactorsCard weights={weights} onWeightChange={handleWeightChange} />
      </div>
    </div>
  );
};

export default WeightSelection;